/* @ngInject */
export function RubricPointsController () {

}
